



import {Component, Prop, Vue} from 'vue-property-decorator';
import MatomoSearchPageVisit from '@/matomo/MatomoSearchPageVisit';
import MatomoSearchMessage from '@/matomo/message/MatomoSearchMessage';

@Component
export default class TrackSearchPageVisit extends Vue {

  @Prop({required: false, default: ''})
  public localNumberOfElementsFound: string;

  @Prop({required: false, default: ''})
  public localQuery: string;

  get numberOfElementsFound(): number {
    if (!this.localNumberOfElementsFound) {
      return 0;
    }
    return parseInt(this.localNumberOfElementsFound, 10);
  }

  public mounted() {
    MatomoSearchPageVisit.withSearchCount(this.numberOfElementsFound).publishPageVisit();
    MatomoSearchMessage.from(this.localQuery, this.numberOfElementsFound).publish();
  }
}
